<template>
  <div class="custom-microcard" @click="linkToDetailView">
    <div>
      <h2 class="first-info">{{ info1 }}</h2>
      <p class="second-info">{{ info2 }}</p>
      <p class="second-info">{{ info3 }}</p>
    </div>
    <div>
      <CircleStatus :status="getStatus(datas.start, datas.end)"></CircleStatus>
    </div>
  </div>
</template>

<script>
import DateTimeManipulation from '../mixins/DateTimeManipulation'
import CircleStatus from './CircleStatus.vue'

  export default {
    components: {
      CircleStatus
    },
    props: {
      type: {
        type: String,
        default: 'unknow'
      },
      datas: {
        type: Object,
      }
    },
    data() {
      return {
        info1: '',
        info2: '',
        info3: '',
      }
    },
    created() {
       if(this.type === 'of') {
          this.info1 = this.datas.name;
          this.info2 = 'Début: ' + this.getReadableFormat(this.datas.start);
          this.info3 = 'Fin: ' + this.getReadableFormat(this.datas.end);
        }
        if(this.type === 'pz') {
          this.info1 = this.datas.name;
          this.info2 = this.datas.beaconId;
          this.info3 = '';
        }
    },
    methods: {
      linkToDetailView: function() {
        this.$router.replace({params: { id: this.datas.id } }).catch(err => {
          console.error(err);
        })
      }
    },
    mixins: [DateTimeManipulation]
  }
</script>

<style scoped>
  .custom-microcard {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    color: #000000;
    border-radius: 4px;
    margin-bottom: 12px;
    padding-top: 1px;
    padding-left: 12px;
    padding-bottom: 4px;
  }

  .custom-microcard:hover {
    cursor: pointer;
  }

  .first-info {
    margin-top: 2px;
    margin-bottom: 4px;
  }

  .second-info {
    /* padding: 2px; */
    margin: 0;
    font-size: 12px;
    color: #303133;
    opacity: 0.6;
  }
</style>